import React, { useRef, useEffect, useState } from 'react';
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import '../map.css';
import axios from 'axios';
import { colors } from '../color';
import { v4 as uuidv4 } from 'uuid';
import { SearchOutlined, AlertFilled, AlertOutlined, PlusOutlined } from '@ant-design/icons';
import { MdLocationOn } from "react-icons/md";
import { ServerIP, SiteUrl } from '../component/ServerIP';
import { FaCrosshairs } from 'react-icons/fa';
import Loader from '../component/Loader';



const ConfirmMap = ({ }) => {

    const params = new URLSearchParams(window.location.search);
    const addressId = params.get('addressId');

    const [search, setSearch] = useState('');

    const [location, setLocation] = useState([]);

    const mapContainer = useRef(null);
    const map = useRef(null);
    const center = { lat: 18.42, lng: -72.57 };

    const [marker, setMarker] = useState(null);
    const [markerPos, setMarkerPos] = useState(null);
    const [loading, setLoading] = useState(false);
    const [starting, setStarting] = useState(true);

    const [zoom] = useState(12);


    useEffect(() => {
        if (map.current) return;

        map.current = new L.Map(mapContainer.current, {
            center: L.latLng(center.lat, center.lng),
            zoom: zoom,
            zoomControl: false,
            minZoom: 3,
            maxZoom: 20,
        });


        L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            subdomains: 'abcd',
            maxZoom: 20
        }).addTo(map.current);

        getAddressPosition();

    }, [center.lat, center.lng, zoom]);




    const getAddressPosition = async () => {
        try {
            if (addressId !== null) {
                const response = await axios.get(`${ServerIP}/address/getAddress/${addressId}`)

                if (response.status === 200) {
                    getPosition({ lat: response.data.lat, lon: response.data.lon })
                }
            }

        } catch (error) {
            console.log(error)
        }
    }



    let userMarker = useRef();
    let addressPosition = null;

    const getPosition = ({ lat, lon }) => {

        setLocation([lat, lon]);

        if (userMarker.current) {
            userMarker.current.remove();
        }

        userMarker.current = L.marker([lat, lon], {
            icon: L.icon({
                iconUrl: require('../data/IconImageMap/riseHand.png'),
                iconSize: [25, 36],
                iconAnchor: [12, 36],
            }),
            draggable: false
        }).addTo(map.current);



        setMarker(userMarker.current);
        map.current.flyTo([lat, lon], map.current.getZoom() + 3);

        setTimeout(() => {
            setStarting(false);
        }, 5000);
    }


    useEffect(() => {
        if (map.current) {
            const centerMap = map.current.getCenter();
            setMarkerPos(centerMap);

            map.current.on('moveend', () => {
                const centerMap = map.current.getCenter();
                setMarkerPos(centerMap);
                // Mettez à jour l'état ou effectuez d'autres actions ici...
            });

            map.current.on('zoomend', () => {
                const centerMap = map.current.getCenter();
                setMarkerPos(centerMap);
                // Mettez à jour l'état ou effectuez d'autres actions ici...
            });
        }
    }, [center.lng, center.lat, zoom]);


    const handleSearch = async (e) => {
        e.preventDefault();

        const response = await axios.get(`https://nominatim.openstreetmap.org/search?format=json&q=${search}`);

        if (response.data.length !== 0) {
            const { lat, lon } = response.data[0];

            // if (userMarker) {
            //     userMarker.remove()
            // }

            // const userIcon = L.icon({ iconUrl: require('../data/IconImageMap/currentLocation.png'), iconSize: [25, 41], iconAnchor: [12, 41] });
            // userMarker = L.marker([lat, lon], { draggable: true }, { icon: userIcon }).addTo(map.current);

            // userMarker.on('move', function (e) {
            //     addressPosition = userMarker.getLatLng();
            //     setMarkerPos(addressPosition);
            // });

            // setMarker(userMarker);
            // setMarkerPos(userMarker._latlng);
            map.current.flyTo([lat, lon], map.current.getZoom() + 1);
        } else {
            console.log("Aucun resultat trouve")
        }

    };


    const confirmAddress = async () => {
        try {
            if (location.length !== 0) {
                const data = {
                    latitude: markerPos.lat,
                    longitude: markerPos.lng,
                }
                const response = await axios.patch(`${ServerIP}/address/confirmAddress/${addressId}`, data)

                if (response.status === 200) {
                    const response1 = await axios.get(`${ServerIP}/address/getAddress/${addressId}`)
                    if (response1.status === 200) {
                        map.current.flyTo([markerPos.lat, markerPos.lng], map.current.getZoom() + 1);
                        setTimeout(() => {
                            window.location.href = `${SiteUrl}/confirm`
                        }, 500);
                    } else {
                        console.log(`Erreur lors de la récupération de l'adresse : ${response1.status}`);
                    }
                } else {
                    console.log(`Erreur lors de la confirmation de l'adresse : ${response.status}`);
                }
            }
        } catch (error) {
            console.log(`Une erreur est survenue : ${error.message}`);
        }
    }


    //Coordinate Position

    const userMarkerRef = useRef(null);
    const intervalIdRef = useRef(null);
    const firstCallRef = useRef(true);

    const getRealTimePositionFunc = async () => {
        intervalIdRef.current = setInterval(getRealTimePosition, 5000);

        if (!map.current.getCenter().equals([location[0], location[1]]) && firstCallRef.current === false) {
            map.current.flyTo([location[0], location[1]], map.current.getZoom());
        }
    }

    const getRealTimePosition = async () => {
        try {
            const position = await new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject, { maximumAge: 5000 });
            });

            const { latitude, longitude } = position.coords;

            setLocation([latitude, longitude]);

            const userIcon = L.icon({
                iconUrl: require('../data/IconImageMap/currentLocation.png'),
                iconSize: [25, 36],
                iconAnchor: [12, 36],
            });

            if (!userMarkerRef.current) {
                userMarkerRef.current = L.marker([position.coords.latitude, position.coords.longitude], { icon: userIcon }).addTo(map.current);
            } else {
                userMarkerRef.current.setLatLng([position.coords.latitude, position.coords.longitude]);
            }

            if (firstCallRef.current === true) {
                map.current.flyTo([latitude, longitude], map.current.getZoom());
                firstCallRef.current = false;
            }

        } catch (error) {
            console.error('Erreur de géolocalisation:', error);
        }
    };

    const [isPressed, setIsPressed] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    return (
        <div className="map-wrap">

            <div ref={mapContainer} className="map" style={{ zIndex: 0, top: 0, height: '80%' }} />


            <div style={{ width: '100%', height: '80%' }}>

                <div
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        right: 25,
                        top: '40%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 1,
                        borderWidth: '1px',
                        backgroundColor: isPressed ? colors.white : colors.accent,
                        height: 50,
                        width: 50,
                        borderRadius: '50%',
                        display: 'flex',
                        alignSelf: 'center',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'transform 0.1s, background-color 0.1s',
                        transform: isPressed ? 'scale(0.95)' : 'scale(1)',
                    }}
                    onMouseDown={() => setIsPressed(true)}
                    onMouseUp={() => setIsPressed(false)}
                    onMouseLeave={() => setIsPressed(false)}
                    onTouchStart={() => setIsPressed(true)}
                    onTouchEnd={() => setIsPressed(false)}
                    onTouchCancel={() => setIsPressed(false)}
                    onClick={getRealTimePositionFunc}
                >
                    <FaCrosshairs size={20} color={colors.black} />
                </div>


                <div
                    style={{
                        position: 'absolute',
                        alignSelf: 'center',
                        justifySelf: 'center',
                        bottom: 100,
                        top: 0,
                        right: 0,
                        left: 0,
                        zIndex: 1,
                        height: 50,
                        width: 50,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <PlusOutlined style={{ color: colors.black, fontSize: '12px' }} />
                </div>

            </div>


            <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', height: '20%', bottom: 20, borderTopRightRadius: 15, borderTopLeftRadius: 15, backgroundColor: colors.white }}>

                <div style={{ height: '70%', width: '98%' }}>
                    <span style={{ display: 'flex', alignSelf: 'center', marginTop: '20px', textAlign: 'center', fontWeight: 700, fontFamily: 'Inter', color: 'gray', fontSize: 17 }}>
                        Indiquez l'emplacement du (+) là où vous souhaitez que le chauffeur vous remette votre colis.
                    </span>
                </div>


                {!loading ? (
                    <div
                        onClick={confirmAddress}
                        style={{
                            width: '90%', display: 'flex', marginLeft: '20px', marginRight: '20px',
                            alignItems: 'center', justifyContent: 'center', height: '55px', backgroundColor: "#C0EC4E", borderRadius: '35px',
                            fontWeight: 700, fontFamily: 'Inter', color: '#03031B', fontSize: 16
                        }}>
                        Confirmer
                    </div>
                ) : (
                    <div
                        onClick={() => { }}
                        style={{
                            width: '90%', display: 'flex', marginLeft: '20px', marginRight: '20px',
                            alignItems: 'center', justifyContent: 'center', height: '55px', backgroundColor: "#C0EC4E", borderRadius: '35px',
                            fontWeight: 700, fontFamily: 'Inter', color: '#03031B', fontSize: 16
                        }}>
                        Chargement...
                    </div>
                )}


            </div>

            <Loader visible={isVisible} />

        </div >
    )

}

export default ConfirmMap;
